import Link from 'next/link'
import Image from 'next/image'
import LogoImg from '@/public/images/logovexub.png'
import { CSSProperties } from 'react'

export default async function Logo({
  height,
  width,
  disableRedirect,
  style
}: {
  height?: number
  width?: number
  disableRedirect?: boolean
  style? : CSSProperties
}) {
  const logo = (
    <Image
      className="max-w-none"
      src={LogoImg}
      width={width ?? 38}
      height={height ?? 38}
      priority
      alt="Vexub"
    />
  )

  return disableRedirect ? (
    <span style={style} className="inline-flex" aria-label="Vexub">
      {logo}
    </span>
  ) : (
    <Link className="inline-flex" href="/app" aria-label="Vexub">
      {logo}
    </Link>
  )
}